import React, { useState } from "react";
import "../../style/pages/categoriespage/stickers.css";
import { useNavigate } from "react-router-dom";

import Header from "../../component/Header.jsx";

import Filter from "../../component/Filter.jsx";
import ItemGrid from "../../component/ItemGrid.jsx";

import s1 from "../../media3/categories/s1.png";
import s2 from "../../media3/categories/s2.png";
import s3 from "../../media3/categories/s3.png";
import s4 from "../../media3/categories/s4.png";
import s5 from "../../media3/categories/s5.png";
import s6 from "../../media3/categories/s6.png";
import s7 from "../../media3/categories/s7.png";
import s8 from "../../media3/categories/s8.png";
import s9 from "../../media3/categories/s9.png";
import s10 from "../../media3/categories/s10.png";
import s11 from "../../media3/categories/s11.png";
import s12 from "../../media3/categories/s12.png";
import s13 from "../../media3/categories/s13.png";
import s14 from "../../media3/categories/s14.png";
import s15 from "../../media3/categories/s15.png";
import s16 from "../../media3/categories/s16.png";
import s17 from "../../media3/categories/s17.png";
import s18 from "../../media3/categories/s18.png";
import s19 from "../../media3/categories/s19.png";
import s20 from "../../media3/categories/s20.png";
import s21 from "../../media3/categories/s21.png";
import s22 from "../../media3/categories/s22.png";
import s23 from "../../media3/categories/s23.png";
import s24 from "../../media3/categories/s24.png";
import s from "../../media3/categories/s.png";

// Dummy data
export const stickersData = [
  { id: 1, name: "Sticker | Slalom", img: s1, price: 61, maxPrice: 122, color: "purple", rating: 4, rarity: "Restricted", orderedBy: "Popularity", currency: "USD", description: "Slalom sticker with purple ski goggles and snow trails, perfect for marking your gear with alpine speed and style." },
  { id: 2, name: "Sticker | Blaze", img: s2, price: 80, maxPrice: 150, color: "blue", rating: 5, rarity: "Covert", orderedBy: "Price", currency: "USD", description: "Blaze sticker engulfed in electric blue flames, igniting your weapon with intense, high-energy flair." },
  { id: 3, name: "Sticker | Fade", img: s3, price: 95, maxPrice: 160, color: "green", rating: 4, rarity: "Classified", orderedBy: "Rating", currency: "USD", description: "Fade sticker in smooth green-to-blue gradient, adding sleek, chromatic elegance to any surface." },
  { id: 4, name: "Sticker | Orion", img: s4, price: 120, maxPrice: 180, color: "purple", rating: 5, rarity: "Covert", orderedBy: "Newest", currency: "USD", description: "Orion sticker featuring cosmic purple constellation patterns, guiding your aim through the stars." },
  { id: 5, name: "Sticker | See Ya Later", img: s5, price: 70, maxPrice: 125, color: "blue", rating: 3, rarity: "Restricted", orderedBy: "Popularity", currency: "USD", description: "See Ya Later sticker with a grinning blue mechanical gator, waving goodbye to your enemies in style." },
  { id: 6, name: "Sticker | Hyper Beast", img: s6, price: 90, maxPrice: 140, color: "green", rating: 4, rarity: "Classified", orderedBy: "Rating", currency: "USD", description: "Hyper Beast sticker roaring with neon green monstrous jaws, unleashing primal aggression on your gear." },
  { id: 7, name: "Sticker | Fuel Injector", img: s7, price: 110, maxPrice: 160, color: "red", rating: 5, rarity: "Covert", orderedBy: "Price", currency: "USD", description: "Fuel Injector sticker in fiery red industrial mechanics, boosting your weapon with raw horsepower." },
  { id: 8, name: "Sticker | Melondrama", img: s8, price: 60, maxPrice: 120, color: "yellow", rating: 3, rarity: "Restricted", orderedBy: "Popularity", currency: "USD", description: "Melondrama sticker with juicy yellow watermelon slices, adding playful, refreshing chaos to your loadout." },
  { id: 9, name: "Sticker | Llama Cannon", img: s9, price: 75, maxPrice: 130, color: "green", rating: 4, rarity: "Classified", orderedBy: "Newest", currency: "USD", description: "Llama Cannon sticker with explosive green llama artillery, blasting quirky firepower onto your skins." },
  { id: 10, name: "Sticker | Kill Confirmed", img: s10, price: 145, maxPrice: 200, color: "purple", rating: 5, rarity: "Covert", orderedBy: "Price", currency: "USD", description: "Kill Confirmed sticker with purple blood splatter and bullet holes—proof of elite, verified eliminations." },
  { id: 11, name: "Sticker | Bullet Queen", img: s11, price: 88, maxPrice: 150, color: "orange", rating: 4, rarity: "Classified", orderedBy: "Rating", currency: "USD", description: "Bullet Queen sticker crowned in regal orange with golden bullets, ruling the battlefield with royal precision." },
  { id: 12, name: "Sticker | Handgun", img: s12, price: 55, maxPrice: 110, color: "white", rating: 3, rarity: "Restricted", orderedBy: "Popularity", currency: "USD", description: "Handgun sticker in clean white silhouette, marking your weapon with classic sidearm simplicity." },
  { id: 13, name: "Sticker | Avalanche", img: s13, price: 68, maxPrice: 125, color: "yellow", rating: 4, rarity: "Restricted", orderedBy: "Newest", currency: "USD", description: "Avalanche sticker in bright yellow snowy rush, charging your gear with winter storm intensity." },
  { id: 14, name: "Sticker | Xiangliu", img: s14, price: 92, maxPrice: 160, color: "yellow", rating: 4, rarity: "Classified", orderedBy: "Price", currency: "USD", description: "Xiangliu sticker coiled in golden yellow mythical serpent scales, guarding your weapon with ancient power." },
  { id: 15, name: "Sticker | Muertos", img: s15, price: 63, maxPrice: 120, color: "purple", rating: 3, rarity: "Restricted", orderedBy: "Popularity", currency: "USD", description: "Muertos sticker with vibrant purple Day of the Dead skulls, honoring tradition with festive lethality." },
  { id: 16, name: "Sticker | Angry Mob", img: s16, price: 85, maxPrice: 140, color: "purple", rating: 5, rarity: "Classified", orderedBy: "Rating", currency: "USD", description: "Angry Mob sticker in chaotic purple protest graffiti, rallying rebellion on your weapon’s surface." },
  { id: 17, name: "Sticker | Cobra Strike", img: s17, price: 78, maxPrice: 130, color: "red", rating: 4, rarity: "Classified", orderedBy: "Newest", currency: "USD", description: "Cobra Strike sticker with striking red venomous fangs, delivering silent, deadly precision." },
  { id: 18, name: "Sticker | Crazy 8", img: s18, price: 59, maxPrice: 110, color: "red", rating: 2, rarity: "Restricted", orderedBy: "Popularity", currency: "USD", description: "Crazy 8 sticker with wild red dice and chaos symbols, gambling on luck and unpredictability." },
  { id: 19, name: "Sticker | Ticket to Hell", img: s19, price: 99, maxPrice: 160, color: "white", rating: 5, rarity: "Classified", orderedBy: "Price", currency: "USD", description: "Ticket to Hell sticker with burning white flames and demons, opening a portal to infernal dominance." },
  { id: 20, name: "Sticker | Water Elemental", img: s20, price: 115, maxPrice: 175, color: "yellow", rating: 5, rarity: "Covert", orderedBy: "Newest", currency: "USD", description: "Water Elemental sticker flowing with glowing yellow liquid energy, submerging your gear in mystical power." },
  { id: 21, name: "Sticker | Asiimov", img: s21, price: 102, maxPrice: 155, color: "yellow", rating: 4, rarity: "Classified", orderedBy: "Rating", currency: "USD", description: "Asiimov sticker in futuristic yellow geometric lines, overclocking your weapon with sci-fi precision." },
  { id: 22, name: "Sticker | Pole Position", img: s22, price: 66, maxPrice: 125, color: "red", rating: 3, rarity: "Restricted", orderedBy: "Popularity", currency: "USD", description: "Pole Position sticker with bold red racing checkers, accelerating your style to the front of the pack." },
  { id: 23, name: "Sticker | Isaac", img: s23, price: 74, maxPrice: 130, color: "black", rating: 4, rarity: "Classified", orderedBy: "Newest", currency: "USD", description: "Isaac sticker with glowing black holographic circuits, enhancing your weapon with electrified tech." },
  { id: 24, name: "Sticker | Boost Protocol", img: s24, price: 97, maxPrice: 160, color: "yellow", rating: 5, rarity: "Covert", orderedBy: "Price", currency: "USD", description: "Boost Protocol sticker with pulsing yellow cyber glow, overclocking your loadout for maximum performance." }
];

const colors = ["red", "green", "blue", "yellow", "purple", "black", "white", "orange"];
const ratings = [5, 4, 3, 2, 1];

function Stickers({ isLoggedIn, setLoginModalOpen, handleLogout }) {
  const [priceRange, setPriceRange] = useState([50, 200]);
  const [selectedColors, setSelectedColors] = useState([]);
  const [selectedRating, setSelectedRating] = useState(null);
  const [openFilter, setOpenFilter] = useState("Price");
    const [selectedRarity, setSelectedRarity] = useState(null);
  const [selectedOrderBy, setSelectedOrderBy] = useState(null);

  const navigate = useNavigate();

  // Filtering
  // const filteredStickers = stickersData.filter((item) => {
  //   const inPrice = item.price >= priceRange[0] && item.price <= priceRange[1];
  //   const inColor = selectedColors.length === 0 || selectedColors.includes(item.color);
  //   const inRating = !selectedRating || item.rating === selectedRating;
  //   return inPrice && inColor && inRating;
  // });
    let filteredStickers = stickersData.filter((pistol) => {
    const inPrice = pistol.price >= priceRange[0] && pistol.price <= priceRange[1];
    const inColor = selectedColors.length === 0 || selectedColors.includes(pistol.color);
    const inRating = !selectedRating || pistol.rating === selectedRating;
    const inRarity = !selectedRarity || selectedRarity === "Any" || pistol.rarity === selectedRarity;
    return inPrice && inColor && inRating && inRarity;
  });
  
  // Add sorting
  if (selectedOrderBy) {
    filteredStickers = [...filteredStickers].sort((a, b) => {
      switch (selectedOrderBy) {
        case "Price":
          return a.price - b.price;
        case "Rating":
          return b.rating - a.rating;
        case "Popularity":
          return a.id - b.id;
        case "Newest":
          return b.id - a.id;
        default:
          return 0;
      }
    });
  }
  
  const handleRarityChange = (rarity) => {
    setSelectedRarity(rarity === selectedRarity ? null : rarity);
  };
  
  const handleOrderByChange = (orderBy) => {
    setSelectedOrderBy(orderBy === selectedOrderBy ? null : orderBy);
  };
  
  
    // Handlers
    const handlePriceChange = (e, idx) => {
      const newRange = [...priceRange];
      newRange[idx] = Number(e.target.value);
      setPriceRange(newRange);
    };
  
    const handleColorChange = (color) => {
      setSelectedColors((prev) =>
        prev.includes(color) ? prev.filter((c) => c !== color) : [...prev, color]
      );
    };

  // Handlers


  const handleRatingChange = (rating) => {
    setSelectedRating(rating === selectedRating ? null : rating);
  };

    const handleNavigate = (itemName) => {
    navigate(`/items/${encodeURIComponent(itemName)}`);
  };


  const toggleSection = (section) => {
    setOpenFilter(openFilter === section ? "" : section);
  };

  return (
    <div className="categories-page">
             <Header
        isLoggedIn={isLoggedIn}
        setLoginModalOpen={setLoginModalOpen}
        handleLogout={handleLogout}
      />
      <div className="categories-content">
             <Filter
          openFilter={openFilter}
          toggleSection={toggleSection}
          priceRange={priceRange}
          handlePriceChange={handlePriceChange}
          selectedColors={selectedColors}
          handleColorChange={handleColorChange}
          selectedRating={selectedRating}
          handleRatingChange={handleRatingChange}
          colors={colors}
          ratings={ratings}
             selectedRarity={selectedRarity}
  handleRarityChange={handleRarityChange}
  selectedOrderBy={selectedOrderBy}
  handleOrderByChange={handleOrderByChange}
        />
        <ItemGrid
          items={filteredStickers}
          categoryImage={s}
          categoryAlt="CZ75-Auto"
          categoryTitle="Sticker | Muertos"
          categoryDescription="ChatGPT said:

Unleash your style with the most sought-after CS2 stickers, where every design adds personality and flair to your arsenal.
From iconic team logos to limited-edition artwork, each sticker tells a story of the CS2 community.
Customize, trade, and display your favorite stickers — making every weapon truly yours"
          onItemClick={handleNavigate}
            isLoggedIn={isLoggedIn}                   
          setLoginModalOpen={setLoginModalOpen}
        />
      </div>
    </div>
  );
}

export default Stickers;